/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class WixxSoundConfig implements ISoundConfig {

    public static instance:WixxSoundConfig = new WixxSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string[] = ["background-music-main", "background-music-main", "background-music-main-break", "background-music-main", "background-music-main-break"];

    RESPIN_MUSIC:string = "respin-music";
    RESPIN_MUSIC_END:string = "respin-music-ends";

    REELS_SPINNING:string = "reels-spinning";
    // REELS_SPINNING_STOP_DELAY:number = 0.15;
    REELS_DEFAULT_BOUNCE:string[] = ["reel-landing", "reel-landing", "reel-landing", "reel-landing"];
    REELS_BOOST_BOUNCE:string[] = ["boost-reel-landing", "boost-reel-landing", "boost-reel-landing", "boost-reel-landing"];

    WILD_LANDING_ATTANTION:string = "wild-hit-reel";

    SYMBOL_TRANSFORM_UP:string = "symbols-transformation-up";
    SYMBOL_LANDING_ON_BURST_REEL:string = "burst-reel-4";

    COUNT_UP_X_SMALL:string = "countup-xsmall";
    COUNT_UP_SMALL:string = "countup-small";
    COUNT_UP_MEDIUM:string = "countup-medium";
    COUNT_UP_LARGE:string = "countup-large";

    WIN_X_SMALL:string = "win-xsmall";
    WIN_SMALL:string = "win-small";
    WIN_MEDIUM:string = "win-medium";
    WIN_LARGE:string = "win-large";

    WIN_BIG_MUSIC:string = "big-win-music";
    WIN_BIG_MUSIC_END:string = "big-win-ends";
    COUNT_UP_BIG:string = "big-win-countup";
    WIN_BIG_BIG:string = "big-win-voice-level-1";
    WIN_BIG_MEGA:string = "big-win-voice-level-2";
    WIN_BIG_SUPER_MEGA:string = "big-win-voice-level-3";
    WIN_BIG_EXTREME:string = "big-win-voice-level-4";

    REEL_NEAR_WIN_1:string = "anticipation-reel-1";
    REEL_NEAR_WIN_2:string = "anticipation-reel-2";
    REEL_NEAR_WIN_3:string = "anticipation-reel-3";
    REEL_NEAR_WIN_4:string = "anticipation-reel-4";
    REEL_NEAR_WIN_FAIL:string = "anticipation-fail";

    constructor() {
        if(WixxSoundConfig.instance) {
            throw new Error("WixxSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinCountUpSoundName(winRatio:IWinRatioConfig | null):string | null {
        if(!winRatio) {
            return null;
        }
        //Tiny
        if(winRatio.type == WinRatioType.TINY) {
            return this.instance.COUNT_UP_X_SMALL;
        }
        //SMALL
        if(winRatio.type == WinRatioType.SMALL) {
            return this.instance.COUNT_UP_SMALL;
        }
        //Medium
        if(winRatio.type == WinRatioType.MEDIUM) {
            return this.instance.COUNT_UP_MEDIUM;
        }
        //Large
        if(winRatio.type == WinRatioType.LARGE) {
            return this.instance.COUNT_UP_LARGE;
        }

        return null;
    }

    static getNormalWinSoundName(winRatio:IWinRatioConfig | null):any {
        if(!winRatio) {
            return null;
        }
        //Tiny
        if(winRatio.type == WinRatioType.TINY) {
            return this.instance.WIN_X_SMALL;
        }
        //SMALL
        if(winRatio.type == WinRatioType.SMALL) {
            return this.instance.WIN_SMALL;
        }
        //Medium
        if(winRatio.type == WinRatioType.MEDIUM) {
            return this.instance.WIN_MEDIUM;
        }
        //Large
        if(winRatio.type == WinRatioType.LARGE) {
            return this.instance.WIN_LARGE;
        }

        return null;
    }

    static getNormalWinSoundDuration(winRatio:IWinRatioConfig | null):any {
        if(winRatio && winRatio.duration) {
            return winRatio.duration;
        }
        return null;
    }
}